(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["os-container"] && !Shopify.designMode) return;
  try {
    // Background video plays muted and looped, but never when the visitor
  // prefers reduced motion; the poster frame shows instead.
  if (!customElements.get('os-background-video')) {
    customElements.define(
      'os-background-video',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video) return;
          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.sync = () => {
            if (this.motion.matches) {
              this.video.pause();
            } else {
              this.video.play().catch(() => {});
            }
          };
          this.sync();
          this.motion.addEventListener('change', this.sync);
        }

        disconnectedCallback() {
          this.motion?.removeEventListener('change', this.sync);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
